// Tarjetas de Check-In: el código que lleva cada tarjeta y su código de barras Code 128
// (lo leen todos los escáneres de mano, USB o Bluetooth).

/**
 * Código de tarjeta tal como se guarda y se busca: sin espacios alrededor y en mayúsculas
 * (un escáner o una persona pueden escribirlo en minúsculas). Letras, números y guiones.
 */
export function normalizePassCode(raw: string): string {
  return raw.trim().toUpperCase();
}

export const PASS_CODE_RE = /^[A-Z0-9][A-Z0-9-]{3,31}$/;

export function isValidPassCode(code: string): boolean {
  return PASS_CODE_RE.test(code);
}

/**
 * Códigos que genera la plataforma: «C» y 8 dígitos. Empiezan con letra para que nunca se
 * confundan con un número de teléfono en la búsqueda del kiosko.
 */
export const GENERATED_PASS_RE = /^C\d{8}$/;

// Anchos de barra/espacio de cada símbolo Code 128 (valores 0–105) y la parada (106).
const PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];
export const CODE128_PATTERNS: readonly string[] = PATTERNS;
const START_B = 104;
const STOP = 106;

/** Valores Code 128 (conjunto B) con inicio, dígito verificador y parada. */
export function code128Values(text: string): number[] {
  if (!text.length) throw new Error('Código vacío');
  const values = [START_B];
  for (const ch of text) {
    const c = ch.charCodeAt(0);
    if (c < 32 || c > 126) throw new Error(`Carácter no admitido en Code 128: ${ch}`);
    values.push(c - 32);
  }
  let sum = START_B;
  for (let i = 1; i < values.length; i++) sum += values[i]! * i;
  values.push(sum % 103, STOP);
  return values;
}

/**
 * Anchos en módulos, alternando barra y espacio (empieza con barra), sin márgenes.
 * Para dibujarlo: cada número es el ancho de una barra negra o de un espacio blanco.
 */
export function code128Widths(text: string): number[] {
  return code128Values(text).flatMap((v) => [...PATTERNS[v]!].map(Number));
}
